import { ENVIRONMENT_CONSTANT } from "./env.constant";

//admin API's start
export const ADMIN_CAMPAIGNS = `${ENVIRONMENT_CONSTANT.API_ENDPOINT}admin/campaigns`;
export const ADMIN_ORGANIZATIONS = `${ENVIRONMENT_CONSTANT.API_ENDPOINT}admin/organizations`;
export const ADMIN_GET_DONATIONS = `${ENVIRONMENT_CONSTANT.API_ENDPOINT}admin/donations`;
export const ADMIN_GET_DONATION_STATS = `${ENVIRONMENT_CONSTANT.API_ENDPOINT}admin/donation-stats`;
export const GET_DAILY_PLAN_STATUS = `${ENVIRONMENT_CONSTANT.API_ENDPOINT}admin/daily-recurring-plans-status`;
//admin API's end